import JSONApiService from "@/services/JSONApiService";
import { USER_MODEL } from "@/models/user-model";
import { LANGUAGE_MODEL } from "@/models/language-model";
import { LANGUAGE_LEVEL_MODEL } from "@/models/language-level-model";
import { DATA } from "@/models/relationships";
import { SKILL_MODEL } from "@/models/skill-model";
import { SKILL_LEVEL_MODEL } from "@/models/skill-level-model";

const languagesAndSkillsApi = commit => ({
  getAllLanguages: async () =>
    JSONApiService(commit)
      .all(DATA)
      .all(LANGUAGE_MODEL)
      .get(),
  getAllSkills: async params =>
    JSONApiService(commit)
      .all(DATA)
      .all(SKILL_MODEL)
      .get(params),
  getUserLanguages: async userId =>
    JSONApiService(commit)
      .one(USER_MODEL, userId)
      .all(LANGUAGE_MODEL)
      .get(),
  getLanguageLevels: async () =>
    JSONApiService(commit)
      .all(DATA)
      .all(LANGUAGE_LEVEL_MODEL)
      .get(),
  getSkillLevels: async () =>
    JSONApiService(commit)
      .all(DATA)
      .all(SKILL_LEVEL_MODEL)
      .get(),
  addUserLanguage: async (userId, data) =>
    JSONApiService(commit)
      .one(USER_MODEL, userId)
      .all(LANGUAGE_MODEL)
      .post(data),
  removeUserLanguage: async (languageId, userId) =>
    JSONApiService(commit)
      .one(USER_MODEL, userId)
      .one(LANGUAGE_MODEL, languageId)
      .destroy(),
  editUserLanguage: async (userId, language) =>
    JSONApiService(commit)
      .one(USER_MODEL, userId)
      .one(LANGUAGE_MODEL, language.id)
      .patch(language),
  addUserSkills: async (userId, data) =>
    JSONApiService(commit)
      .one(USER_MODEL, userId)
      .all(SKILL_MODEL)
      .post(data),
  getUserSkills: async userId =>
    JSONApiService(commit)
      .one(USER_MODEL, userId)
      .all(SKILL_MODEL)
      .get()
});

export default languagesAndSkillsApi;
